import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/**
 * react-snap hydration support.
 *
 * In production we run react-snap as a postbuild step to generate static
 * HTML for public routes (home, about, graveyard, etc.) — giving search
 * engines and link unfurlers real content to crawl instead of the SPA
 * shell. react-snap injects a `window.snapSaveState` call during its
 * crawl and puts the prerendered markup into #root. On real-user page
 * loads we have to `hydrateRoot` that prerendered markup (not
 * `createRoot`), otherwise React throws out the HTML and we lose the
 * SEO value and get a flash of unstyled content.
 *
 * The detection trick: react-snap leaves the markup inside #root; on a
 * fresh SPA load #root starts empty. If it has children, hydrate; else
 * create fresh. This is the pattern documented in react-snap's README.
 */
const rootElement = document.getElementById('root') as HTMLElement;

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
